const initialSubClaimType = {
    subClaimTypePermissions: {},
    subClaimTypeLists: [],
    subClaimTypeListsId: {},
    subClaimTypeStatus: [],
    changedSubClaimTypeStatus: [],
    loadingSubClaimType: false,
    errorsSubClaimType: {}
}

const subClaimTypeReducer = (state = initialSubClaimType, action) => {
    switch (action.type) {
        case "GET_SUB_CLAIM_TYPE_LIST_PENDING":
        case "ADD_SUB_CLAIM_TYPE_PENDING":
        case "UPDATE_SUB_CLAIM_TYPE_PENDING":
        case "UPDATE_SUB_CLAIM_TYPE_STATUS_PENDING":
        case "DELETE_SUB_CLAIM_TYPE_PENDING":
        case "GET_SUB_CLAIM_TYPE_LIST_BY_ID_PENDING":
            return { ...state, loadingSubClaimType: true };

        case "GET_SUB_CLAIM_TYPE_LIST_FULFILLED":
            return {
                ...state,
                loadingSubClaimType: false,
                subClaimTypeLists: action.payload,
                subClaimTypeCount: action.subClaimTypeCount,
                subClaimTypePermissions: action.permissions,
            };

        case "ADD_SUB_CLAIM_TYPE_FULFILLED":
            return {
                ...state,
                loadingSubClaimType: false,
                changedSubClaimTypeStatus: action.payload,
            };

        case "UPDATE_SUB_CLAIM_TYPE_FULFILLED":
            return {
                ...state,
                loadingSubClaimType: false,
                changedSubClaimTypeStatus: action.payload,
            };

        case "UPDATE_SUB_CLAIM_TYPE_STATUS_FULFILLED":
            return {
                ...state,
                loadingSubClaimType: false,
                changedSubClaimTypeStatus: action.payload,
            };

        // Kept separate from subClaimTypeLists so the listing grid isn't overwritten by a single record
        case "GET_SUB_CLAIM_TYPE_LIST_BY_ID_FULFILLED":
            return {
                ...state,
                loadingSubClaimType: false,
                subClaimTypeListsId: action.payload
            };

        case "RESET_SUB_CLAIM_TYPE_LIST_BY_ID":
            return { ...state, subClaimTypeListsId: {} };

        case "DELETE_SUB_CLAIM_TYPE_FULFILLED":
            return {
                ...state,
                loadingSubClaimType: false,
                changedSubClaimTypeStatus: action.payload
            };

        case "RESET_DELETE_SUB_CLAIM_TYPE_STATUS":
            return {
                ...state,
                loadingSubClaimType: false,
                changedSubClaimTypeStatus: [],
                errorsSubClaimType: {}
            };

        case "GET_SUB_CLAIM_TYPE_LIST_REJECTED":
        case "ADD_SUB_CLAIM_TYPE_REJECTED":
        case "UPDATE_SUB_CLAIM_TYPE_REJECTED":
        case "UPDATE_SUB_CLAIM_TYPE_STATUS_REJECTED":
        case "DELETE_SUB_CLAIM_TYPE_REJECTED":
        case "GET_SUB_CLAIM_TYPE_LIST_BY_ID_REJECTED":
            return {
                ...state,
                loadingSubClaimType: false,
                errorsSubClaimType: action.payload
            };

        default:
            return state;
    }
}

export default subClaimTypeReducer;